import type { Job } from "../types/job";
import { AI_BLOCK, classifyAiProviderError } from "../../../../common/ai_provider_errors.es6";

type Translate = (key: string, opts?: Record<string, any>) => string;

const SAFETY = /safety|guardrail|content.?filter|prohibited.?content/i;
const BALANCE = /insufficient.?balance|insufficient.?credit|not enough credit/i;
// Video/avatar safety blocks come from the narration audio — that one has its
// own message; anything else (image edits, text-to-image…) gets the general one.
const VIDEO_TYPE = /video|avatar|lipsync/i;

// A job row's `error` is the server/provider message — English and often
// technical ("Request failed with status code 500", a JSON dump). Show a
// localized sentence instead, picked by the causes the user can act on.
export function jobErrorText(job: Pick<Job, "type" | "error">, t: Translate): string {
  const raw = String(job.error || "");
  if (BALANCE.test(raw)) return t("errors.insufficientBalance");
  // Provider refusals (see ai_provider_errors.es6): copyright/celebrity blocks
  // have their own text; safety blocks fall through to the type-aware one.
  const kind = classifyAiProviderError(raw);
  if (kind === AI_BLOCK.COPYRIGHT) return t("errors.aiCopyrightBlocked");
  if (kind === AI_BLOCK.SAFETY || SAFETY.test(raw)) {
    return VIDEO_TYPE.test(job.type || "")
      ? t("errors.geminiSafetyBlocked")
      : t("errors.safetyBlocked");
  }
  return t("errors.generic");
}
